
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/download/[product]",
      function () {
        return require("private-next-pages/support/download/[product].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/support/download/[product]"])
      });
    }
  